<obg-m-dropdown-menu #menu>
	<button
		class="obg-m-language-selector-button"
		*ngIf="currentMarket$ | async as currentMarket"
		mat-mini-fab
		trigger
		matTooltip="{{currentMarket.name}}"
		matTooltipClass="obg-m-navigation-tooltip"
		test-id="language-selector-button"
		[obgInteraction]="languageTrackingData"
	>
		{{ currentMarket.languageCode }}
	</button>
	<obg-m-language-selector-menu menu [flags]="flags" test-id="language-selector"></obg-m-language-selector-menu>
</obg-m-dropdown-menu>
<obg-m-language-selector-menu
	class="obg-m-language-selector-persistent-content"
	[flags]="flags"
	test-id="language-selector"
></obg-m-language-selector-menu>
